module.exports = __webpack_public_path__ + "static/img/d.d8405a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/d.png
// module id = AGW9
// module chunks = 1